import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from 'i18next';

import english from './locales/en.json';
import spanish from './locales/es.json';

export const CLOUD_NAMESPACE = 'cloud';

i18n.addResourceBundle('en', CLOUD_NAMESPACE, english, true, true);
i18n.addResourceBundle('es', CLOUD_NAMESPACE, spanish, true, true);

export function CloudI18nProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  return (
    <I18nextProvider i18n={i18n} defaultNS={CLOUD_NAMESPACE}>
      {children}
    </I18nextProvider>
  );
}

export function getCloudResources() {
  return { en: english, es: spanish } as const;
}
